import { WindowTitle } from "@saleor/components/WindowTitle";
import { sectionNames } from "@saleor/intl";
import { asSortParams } from "@saleor/utils/sort";
import { parse as parseQs } from "qs";
import React from "react";
import { useIntl } from "react-intl";
import { Route, RouteComponentProps, Switch } from "react-router";

import {
  rotaryAddPath,
  RotaryAddUrlQueryParams,
  rotaryListPath,
  RotaryListUrlQueryParams,
  RotaryListUrlSortField,
  rotaryPath,
  RotaryUrlQueryParams
} from "./urls";
import RotaryCreateComponent from "./views/RotaryCreate";
import RotaryDetailsComponent from "./views/RotaryDetails";
import RotaryListComponent from "./views/RotaryList";

const RotaryList: React.FC<RouteComponentProps<{}>> = ({ location }) => {
  const qs = parseQs(location.search.substr(1));
  const params: RotaryListUrlQueryParams = asSortParams(
    qs,
    RotaryListUrlSortField
  );
  return <RotaryListComponent params={params} />;
};

const RotaryCreate: React.FC<RouteComponentProps<{}>> = ({ location }) => {
  const qs = parseQs(location.search.substr(1));
  const params: RotaryAddUrlQueryParams = qs;
  return <RotaryCreateComponent params={params} />;
};

const RotaryDetails: React.FC<RouteComponentProps<{ id: string }>> = ({
  location,
  match
}) => {
  const qs = parseQs(location.search.substr(1));
  const params: RotaryUrlQueryParams = qs;
  return (
    <RotaryDetailsComponent
      id={decodeURIComponent(match.params.id)}
      params={params}
    />
  );
};

export const RotarySection: React.FC = () => {
  const intl = useIntl();

  return (
    <>
      <WindowTitle title={intl.formatMessage(sectionNames.rotary)} />
      <Switch>
        <Route exact path={rotaryListPath} component={RotaryList} />
        <Route exact path={rotaryAddPath} component={RotaryCreate} />
        <Route path={rotaryPath(":id")} component={RotaryDetails} />
      </Switch>
    </>
  );
};
export default RotarySection;
